/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 scene.gltf
Author: bariacg (https://sketchfab.com/bariacg)
License: CC-BY-NC-4.0 (http://creativecommons.org/licenses/by-nc/4.0/)
Source: https://sketchfab.com/3d-models/orange-a9d71a86a8344606be0e512669b4acc5
Title: Orange
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function Model(props) {
  const { nodes, materials } = useGLTF("/scene.gltf");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Orange_Orange_0.geometry}
        material={materials.Orange}
        scale={1.5}
      />
    </group>
  );
}

useGLTF.preload("/scene.gltf");
